// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1RSY_G_s4CWgkHTQOrTKDp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/ContactSearch/ContactList/ContactList.css
// module id = 570
// module chunks = 0